/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Users_Deactivate_DescriptionInputs */

const en_users_deactivate_description = /** @type {(inputs: Users_Deactivate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This will prevent ${i?.displayName} from signing in. You can re-enable them later.`)
};

const pt_br2_users_deactivate_description = /** @type {(inputs: Users_Deactivate_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Isso impedirá que ${i?.displayName} faça login. Você pode reativar depois.`)
};

/**
* | output |
* | --- |
* | "This will prevent {displayName} from signing in. You can re-enable them later." |
*
* @param {Users_Deactivate_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_deactivate_description = /** @type {((inputs: Users_Deactivate_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Deactivate_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_deactivate_description(inputs)
	return pt_br2_users_deactivate_description(inputs)
});